<template>
<div class="chapter">
<div class="inner_page">
<p class="copy">Copyright © 2008<br/>
  By Jeff Dwyer<br/>
  All rights reserved</p>
<p class="copy1"><i>The word “Pelican” and the depiction of a pelican are trademarks of Pelican Publishing Company, Inc., and are registered in the U.S. Patent and Trademark Office.</i></p>
<p class="copy2"><b>Library of Congress Cataloging-in-Publication Data</b></p>
<p class="copy3">Dwyer, Jeff.</p>
<p class="copy4">Ghost hunter's guide to Seattle and Puget Sound / by Jeff Dwyer.<br/>
  p. cm.</p>
<p class="copy4">Includes index.</p>
<p class="copy5">ISBN-13: 978-1-58980-517-0 (pbk. : alk. paper); 9781455604937(ebook) 1. Ghosts—Washington (State)—Seattle. 2. Haunted places—Washington (State)—Seattle. 3. Ghosts—Washington (State)—Puget Sound. 4. Haunted places—Washington (State)—Puget Sound. I. Title.</p>
<p class="copy4">BF1472.U6D869 2008</p>
<p class="copy4">133.109797'77—dc22</p>
<p class="copy6">2008002459</p>
<p class="logo"><img alt="img" src="Images/logo1.jpg"/></p>
<p class="copy7">Printed in the United States of America</p>
<p class="copy7">Published by Pelican Publishing Company, Inc.</p>
<p class="copy7">1000 Burmaster Street, Gretna, Louisiana 70053</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_9781589805170_Copyright.vue?01f9a2a6